function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import Modal from "../Modal";
import RichProgress from "../RichProgress";
import useStyles from "./style";
var ProgressModal = function ProgressModal(props) {
  var steps = props.steps,
    desc = props.desc,
    successIcon = props.successIcon,
    errorIcon = props.errorIcon,
    strokeColor = props.strokeColor,
    trailColor = props.trailColor,
    strokeErrorColor = props.strokeErrorColor;
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    className: cx(styles.progressModalContainer, prefixCls + '-progress-modal-container')
  }), desc, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.progressBarContainer, prefixCls + '-progress-bar-container')
  }, /*#__PURE__*/React.createElement(RichProgress, {
    stepsData: steps,
    strokeColor: strokeColor,
    trailColor: trailColor,
    strokeErrorColor: strokeErrorColor,
    successIcon: successIcon,
    errorIcon: errorIcon
  })));
};
export default /*#__PURE__*/memo(ProgressModal);